import { TimerAlertOutlineIcon } from './TimerAlertOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 4F3E2A6F-20C4-4EB4-8086-C8A7D1B55283
 * name timer-alert-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-alert-outline.svg
 * tags
 * - Date / Time 
 * - Alert / Error 
 */
export const StopwatchAlertOutlineIcon = TimerAlertOutlineIcon;
export default StopwatchAlertOutlineIcon